<template>
  <div class="content">
    <column-title title="Publications"></column-title>
    <template v-for="(pub,index) in publications" :key="pub.title">
      <div v-if="showYear(pub.year)" class="publication-year">{{ pub.year }}</div>
      <Publication v-bind="pub">{{ publications.length - index }}.&nbsp;</Publication>
    </template>
    <el-backtop target=".scrollbar .el-scrollbar__wrap" bottom="200"></el-backtop>
  </div>
</template>

<script>

import Publication from "@/components/Publication";
import publications from '@/assets/data/publications.js';
import ColumnTitle from "@/components/ColumnTitle";

let lastShowYear = 0;
export default {
  name: "Publications",
  components: {
    ColumnTitle,
    Publication
  },
  data() {
    return {
      publications: publications,
    }
  },
  methods: {
    showYear(year) {
      if (year !== lastShowYear) {
        lastShowYear = year
        return true
      }
      return false
    }
  }
}
</script>

<style scoped>
.content {
  width: 80%;
  margin: auto;
}

.publication-year {
  color: dodgerblue;
  font-size: 18px;
  font-weight: bold;
}

</style>